import React, { useState } from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import BasicModal from "../../core/BaseComponents/Modal";

const CustomizeWelcomeScreenList = (props) => {
    const [showPreviewPopUp, setShowPreviewPopUp] = useState('');

      const renderVideoPreview = (row)=>{
        return row?.videoUrl ? <div className="screen-saver-video d-flex">
          <video width="400" controls={false} preload="metadata" onClick={() => setShowPreviewPopUp(row?.videoUrl)}>
            <source src={`${row?.videoUrl}#t=0.1`} type="video/mp4" />
          </video>
        </div>:"NA"
      }

    const columns = [
        { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "text", headerName: "Config Name", flex: 1 },
        { field: 'imageUrl', headerName: 'Image Preview', flex: 1, row: true, renderCell: (row) => (<img src={row?.imageUrl} alt={row?.sid} className="background-config-img" onClick={() => setShowPreviewPopUp(row?.imageUrl)} />), disableSortIcon: true, },
        {
          field: 'videoUrl', headerName: 'Video Preview', flex: 1, row: true, renderCell: renderVideoPreview, disableSortIcon: true,
        },
    ];

    return (
        <div className="hotel-list">
            <p><b>Welcome Screen Config Details</b></p>
            <TableWrapper
                data={[props?.customizeWelcomeConfigList]}
                columns={columns}
                noPagination={true}
                module="cdsndetails-welcomescreen"
            />
            {showPreviewPopUp&&<BasicModal
                popupOpen={showPreviewPopUp}
                popupCloseHandler={() => { setShowPreviewPopUp('') }}
                isCross={true}
                heading={`Welcome Screen ${showPreviewPopUp?.split('.').pop() === "mp4" ? "Video" : "Image"} Preview`}
                popupSize={`px-5 col-8`}
                bodyMessage={
                    <div className="preview-banner-img">
                        {showPreviewPopUp?.split('.').pop() === "mp4" ? <video className="w-100" controls={true} preload="metadata" >
                            <source src={`${showPreviewPopUp}`} type="video/mp4" />
                        </video> :
                            <img src={showPreviewPopUp} alt='bg-image' width={100}  />}
                    </div>
                }
            />}
        </div>
    )
}

export default CustomizeWelcomeScreenList;